var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLegendBuilderPathi = function SvgLegendBuilderPathi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: props.color || 'currentColor',
    rx: 2
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.679 8.004a2.09 2.09 0 0 0 1.425 1.931 1.7 1.7 0 0 1-.339.8 2 2 0 0 1-1.7.6 4.1 4.1 0 0 0-2.1.533v-2a1.945 1.945 0 0 0 1.356-1.864 1.98 1.98 0 0 0-2.036-2 1.98 1.98 0 0 0-2.035 2 1.945 1.945 0 0 0 1.357 1.865v4.267a1.945 1.945 0 0 0-1.357 1.868 1.98 1.98 0 0 0 2.036 2 1.98 1.98 0 0 0 2.035-2 1.945 1.945 0 0 0-1.357-1.868 1.7 1.7 0 0 1 .407-.867 2.08 2.08 0 0 1 1.7-.6 3.28 3.28 0 0 0 2.779-1.133 3.35 3.35 0 0 0 .611-1.667 2 2 0 0 0-.747-3.865 1.98 1.98 0 0 0-2.035 2m-4.071 0a.636.636 0 0 1 .679-.667.667.667 0 1 1 0 1.334.636.636 0 0 1-.68-.667zm1.356 8a.636.636 0 0 1-.679.667.636.636 0 0 1-.678-.667.636.636 0 0 1 .679-.667.636.636 0 0 1 .678.667m5.429-8a.636.636 0 0 1-.679.667.667.667 0 1 1 0-1.334.636.636 0 0 1 .679.667"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLegendBuilderPathi);
export default ForwardRef;